import { render, staticRenderFns } from "./pdfView.vue?vue&type=template&id=a828e142&scoped=true&"
import script from "./pdfView.vue?vue&type=script&lang=js&"
export * from "./pdfView.vue?vue&type=script&lang=js&"
import style0 from "./pdfView.vue?vue&type=style&index=0&id=a828e142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a828e142",
  null
  
)

export default component.exports